import mixins from '@synergycms_core/less/mixins.js';
export default {
  roboto11Black400: {
    font: "400 11px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto11Black700: {
    font: "700 11px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto11DarkGray: {
    font: "300 11px 'Roboto', sans-serif",
    color: '#333',
    display: 'block'
  },
  roboto11Gold400: {
    font: "400 11px 'Roboto', sans-serif",
    color: data => data.mainColor
  },
  roboto11Gray400: {
    font: "400 11px 'Roboto', sans-serif",
    color: '#333',
    display: 'block'
  },
  roboto11SoftGray: {
    font: "300 11px 'Roboto', sans-serif",
    color: '#9b9b9b'
  },
  roboto11SoftGray300: {
    font: "300 11px 'Roboto', sans-serif",
    color: '#666666'
  },
  roboto11SoftGray400: {
    font: "400 11px 'Roboto', sans-serif",
    color: '#9b9b9b'
  },
  roboto11White: {
    font: "400 11px 'Roboto', sans-serif",
    color: '#fff',
    '@media (min-width: 801px)': {
      font: "400 16px 'Roboto', sans-serif",
      color: '#fff'
    }
  },
  roboto13Gray: {
    font: "300 13px 'Roboto', sans-serif",
    color: '#666'
  },
  roboto13Black400: {
    font: "400 13px 'Roboto', sans-serif",
    color: '#000',
    display: 'block'
  },
  roboto13SoftGray: {
    font: "300 13px 'Roboto', sans-serif",
    color: '#9b9b9b'
  },
  roboto14SoftGray: {
    font: "300 14px 'Roboto', sans-serif",
    color: '#9b9b9b'
  },
  roboto15Black:{
    font: "300 15px 'Roboto', sans-serif",
    color: '#000',
  },
  roboto15GrayBold: {
    font: "500 15px 'Roboto', sans-serif",
    color: '#666'
  },
  roboto15GreenBold: {
    font: "500 15px 'Roboto', sans-serif",
    color: '#5CA70A'
  },
  roboto119b400: {
    font: "300 11px 'Roboto', sans-serif",
    color: '#333',
    textTransform: 'capitalize',
    display: 'block',
    '@media (min-width: 801px)': {
      color: '#9b9b9b'
    }
  },
  promoDescription: {
    '@media (min-width: 801px)': {
      lineHeight: '1.43',
      minHeight: '100px',
      display: 'block'
    }
  },
  roboto13DarkGray: {
    font: "300 13px 'Roboto', sans-serif",
    color: '#333'
  },
  roboto13Gold: {
    font: "400 13px 'Roboto', sans-serif",
    color: data => data.mainColor,
    '@media (min-width: 801px)': {
      fontSize: '16px'
    }
  },
  roboto13Black: {
    font: "300 13px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto14Gray: {
    font: "normal 14px 'Roboto', sans-serif",
    color: '#666'
  },
  roboto14Gray300: {
    font: "300 14px 'Roboto', sans-serif",
    color: '#666'
  },
  roboto14Gold: {
    font: "normal 14px 'Roboto', sans-serif",
    color: data => data.mainColor
  },
  roboto13BoldBlack: {
    font: "500 13px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto14BoldBlack: {
    font: "500 13px 'Roboto', sans-serif",
    color: '#000',
    '@media (min-width: 801px)': {
      fontSize: '14px'
    }
  },
  roboto14Black: {
    font: "300 14px 'Roboto', sans-serif",
    color: '#000',
    outline: 'none',
    '@media (min-width: 801px)': {
      fontSize: '14px'
    }
  },
  roboto16Black: {
    font: "300 16px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto16Black400: {
    font: "400 16px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto16SoftGray400: {
    font: "400 16px 'Roboto', sans-serif",
    color: '#9b9b9b'
  },
  roboto16BlackItalic: {
    font: "300 16px 'Roboto', sans-serif",
    color: '#000',
    fontStyle: 'italic'
  },
  roboto16White: {
    font: "400 9px 'Roboto', sans-serif",
    color: '#fff',
    '@media (min-width: 801px)': {
      fontSize: '16px'
    }
  },
  roboto16BoldBlack: {
    font: "500 16px 'Roboto', sans-serif",
    color: '#000',
    display: 'block'
  },
  roboto16BolderBlack: {
    font: "600 16px 'Roboto', sans-serif",
    color: '#000',
    display: 'block'
  },
  roboto16BoldBlack400: {
    font: "400 16px 'Roboto', sans-serif",
    color: '#000',
    display: 'block'
  },
  roboto16BlackModified: {
    font: "300 13px 'Roboto', sans-serif",
    color: '#000',
    '@media (min-width: 801px)': {
      fontSize: '16px'
    }
  },
  roboto16BlackModified2: {
    font: "300 14px 'Roboto', sans-serif",
    color: '#000',
    '@media (min-width: 801px)': {
      fontSize: '16px'
    }
  },
  roboto16BoldGold: {
    font: "500 16px 'Roboto', sans-serif",
    color: data => data.mainColor
  },
  roboto16Bold400Gold: {
    font: "500 16px 'Roboto', sans-serif",
    color: data => data.mainColor
  },
  roboto16SoftGray: {
    font: "300 16px 'Roboto', sans-serif",
    color: '#8c8c8c'
  },
  roboto18Black: {
    font: "300 18px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto18Black700: {
    font: "700 18px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto20Black: {
    font: "300 20px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto19White: {
    font: "300 19px 'Roboto', sans-serif",
    color: '#fff'
  },
  roboto24Black: {
    font: "300 24px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto24BoldBlack: {
    font: "500 24px 'Roboto', sans-serif",
    color: '#000',
    display: 'block'
  },
  roboto24Bold400Black: {
    font: "400 24px 'Roboto', sans-serif",
    color: '#000'
  },
  roboto32Black: {
    font: "300 32px 'Roboto', sans-serif",
    color: '#000'
  },
  droidSerif18Gray: {
    font: "300 18px 'Droid Serif'",
    color: '#666'
  },
  droidSerif18Black: {
    font: "300 18px 'Droid Serif'",
    color: '#000'
  },
  droidSerif24Black: {
    font: "300 24px 'Droid Serif'",
    color: '#000'
  },
  droidSerif24Black400: {
    font: "400 24px 'Droid Serif'",
    color: '#000'
  },
  droidSerif16BlackBold: {
    font: "bold 16px 'Droid Serif'",
    color: '#000'
  },
  toggleMainButton: {
    font: "400 16px 'Open Sans',sans-serif",
  },
  roomTitle: {
    font: "500 18px/1.25 'Roboto', sans-serif",
    width: '100%',
    textAlign: 'left',
    display: 'block',
    boxSizing: 'border-box',
    color: '#000',
    marginBottom: '10px',
    outline: 'none',
    '&:lang(ar)': {
      textAlign: 'right'
    },
    '@media (min-width: 801px)': {
      fontSize: '24px',
      marginBottom: '15px'
    }
  },
  overflowText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '130px'
  },
  circleSecond: {
    color: '#fff',
    background: 'rgba(187,187,187,0.87)',
    WebkitBorderRadius: '50%',
    MozBorderRadius: '50%',
    borderRadius: '50%',
    position: 'absolute',
    left: '0',
    top: '50%',
    marginTop: '-15px',
    lineHeight: '23px',
    textAlign: 'center',
    height: '23px',
    width: '23px',
    fontSize: '13px',
    '&:lang(ar)': {
      left: 'auto',
      right: '0'
    },
    '@media (min-width: 801px)': {
      fontWeight: '300',
      height: '34px',
      width: '34px',
      lineHeight: '34px',
      marginTop: '-17px',
      fontSize: '24px'
    }
  },
  disabled: {
    background: '#bbb'
  },
  enabled: {
    background: '#5ca70a'
  },
  hide: {
    display: 'none'
  },
  normal: {
    fontWeight: 'normal'
  },
  bold: {
    fontWeight: 'bold'
  },
  uppercase: {
    textTransform: 'uppercase'
  },
  capitalize: {
    textTransform: 'capitalize'
  },
  ucfirst: {
    display: 'inline-block',
    textTransform: 'lowercase',
    '&:first-letter': {
      textTransform: 'uppercase'
    }
  },
  mainColor: {
    color: data => data.mainColor
  },
  white: {
    color: '#fff'
  },
  green: {
    color: '#5ca70a'
  },
  blue: {
    color: '#4a90e2'
  },
  titleHeader: {
    marginBottom: '10px',
    display: 'block',
    font: data => '500 16px/1.25 ' + data.fontFamily1,
    '@media (min-width: 801px)': {
      fontSize: '24px',
      fontWeight: 'normal',
      marginBottom: '10px'
    }
  },
  borderRightSoft: {
    borderRight: '1px solid #d8d8d8',
    '&:lang(ar)': {
      borderLeft: '1px solid #d8d8d8',
      borderRight: 'none'
    }
  },
  marginLeft5: {
    marginRight: '5px',
    '&:lang(ar)': {
      marginRight: '0px',
      marginLeft: '5px'
    }
  },
  availDiscount: {
    fontFamily: "'Roboto', sans-serif",
    background: '#4a90e2',
    WebkitBorderRadius: '4px',
    MozBorderRadius: '4px',
    borderRadius: '4px',
    color: '#fff',
    display: 'inline-block',
    minHeight: '15px',
    marginRight: '6px',
    padding: '4px',
    textAlign: 'center',
    minWidth: '34px',
    verticalAlign: 'middle',
    fontSize: '13px',
    fontWeight: '500',
    border: '1px solid #1e74d9',
    letterSpacing: '0.3px',
    boxSizing:'border-box',
    outline: 'none',
    '@media (min-width: 901px)': {
      fontSize: '16px',
    },
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '6px',
      direction: 'ltr',
    }
  },

  availBestPrice: {
    fontFamily: "'Roboto', sans-serif",
    color: '#5ca70a',
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: '11px',
    width: '54px',
    boxSizing: 'content-box',
    border: '0',
    margin: '0',
    padding: '0',
    textTransform: 'uppercase'
  },
  floatleft: {
    float: 'left',
    '&:lang(ar)': {
      float: 'right'
    }
  },
  stastarModaldtitle: {
    textTransform: 'uppercase',
    fontWeight: '500',
    marginBottom: '24px',
    color: '#000',
    display: 'block'
  },
  child: {
    position: 'relative',
    fontSize: '13px',
    marginLeft: '2px',
    textTransform: 'capitalize',
    display: 'inline-block',
    '&:lang(ar)': {
      marginRight: '2px',
      marginLeft: '0'
    },
    '@media (min-width: 801px)': {
      fontSize: '16px',
      marginLeft: '5px',
      '&:lang(ar)': {
        marginLeft: '0',
        marginRight: '5px'
      }
    }
  },
  adult: {
    marginLeft: '2px',
    fontSize: '13px',
    textTransform: 'capitalize',
    display: 'inline-block',
    verticalAlign: 'baseline',
    '&:lang(ar)': {
      marginRight: '2px',
      marginLeft: '0'
    },
    '@media (min-width: 801px)': {
      fontSize: '16px',
      paddingRight: '5px',
      marginLeft: '5px',
      '&:lang(ar)': {
        paddingRight: '0',
        paddingLeft: '5px',
        marginLeft: '0',
        marginRight: '5px'
      }
    }
  },
  selecRoom: {
    display: 'inline-block',
    color: '#8c8c8c',
    fontSize: '16px',
    verticalAlign: 'middle',
    marginBottom: '10px',
    position: 'relative',
    paddingLeft: '25px',
    '&:lang(ar)': {
      paddingLeft: '0',
      paddingRight: '25px'
    }
  },
  numberRoom: {
    fontWeight: '500',
    marginBottom: '5px',
    fontSize: '13px',
    display: 'inline-block',
    verticalAlign: 'middle',
    '@media (min-width: 801px)': {
      margin: '0 8px 10px 0',
      position: 'relative',
      textAlign: 'left',
      fontSize: '24px',
      '&:lang(ar)': {
        marginLeft: '8px',
        marginRight: '0'
      }
    }
  },
  titleRoom: {
    fontWeight: '500',
    marginBottom: '5px',
    fontSize: '13px',
    display: 'inline-block',
    verticalAlign: 'middle',
    '@media (min-width: 801px)': {
      margin: '0 8px 10px 0',
      position: 'relative',
      fontSize: '24px',
      paddingLeft: '40px',
      '&:lang(ar)': {
        paddingRight: '40px',
        paddingLeft: '0',
        marginLeft: '8px',
        marginRight: '0'
      }
    }
  },
  editTitle: {
    fontSize: '16px',
    '@media (min-width: 801px)': {
      textTransform: 'capitalize',
      marginLeft: '7px',
      marginRight: '10px',
      '&:lang(ar)': {
        marginLeft: '10px',
        marginRight: '7px'
      }
    }
  },
  monoHotelPrice: {
    font: "300 13px 'Roboto', sans-serif",
    marginLeft: '5px',
    '&:lang(ar)': {
      marginRight: '5px',
      marginLeft: '0'
    }
  },
  hideEdit: {
    display: 'none'
  },
  roomSize: {
    display: 'table-cell',
    fontSize: '13px',
    color: '#666',
    verticalAlign: 'middle',
    width: '16%',
    padding: '0 3px',
    '@media (min-width: 801px)': {
      fontSize: '14px',
      padding: '0 14px 0 0',
      display: 'inline-block',
      width: 'auto',
      marginRight: '14px',
      '&:lang(ar)': {
        marginRight: '0',
        marginLeft: '14px',
        paddingRight: '0',
        paddingLeft: '14px',
        display: 'inline-flex',
      }
    }
  },
  roomOf: {
    font: data => '300 13px ' + data.fontFamily1,
    '@media (min-width: 801px)': {
      fontSize: '24px'
    }
  },
  roomNumber: {
    font: data => '300 13px ' + data.fontFamily1,
    '@media (min-width: 801px)': {
      fontSize: '24px'
    }
  },
  subtextTitle: {
    textTransform: 'uppercase',
    display: 'block',
    marginBottom: '15px'
  },
  selectedText: {
    letterSpacing: '1px',
    textTransform: 'capitalize',
    '& span': {
      marginRight: '5px',
      display: 'inline-block',
      '&:lang(ar)': {
        marginRight: '0',
        marginLeft: '5px'
      }
    },
    '@media (min-width: 801px)': {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginBottom: '10px'
    }
  },
  taxesAvail: {
    display: 'inline-block',
    marginTop: '6px',
    textTransform: 'capitalize'
  },
  totalPrice: {
    font: data => 'bold 16px ' + data.fontFamily1,
    display: 'block',
    '@media (min-width: 801px)': {
      fontSize: '20px'
    }
  },
  sinceText: {
    font: data => '11px ' + data.fontFamily1,
    color: '#9b9b9b',
    textAlign: 'right',
    display: 'block',
    textTransform: 'uppercase',
    '&:lang(ar)': {
      textAlign: 'left'
    }
  },
  descriptionText: {
    color: '#000',
    font: "300 13px 'Roboto'",
    display: 'block'
  },
  noAvailText: {
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '6px',
    zIndex: '-1',
    lineHeight: '22px',
    pointerEvents: 'none',
    '&:lang(ar)': {
      left: 'auto',
      right: '6px'
    },
    '@media (min-width: 801px)': {
      display: 'block',
      writingMode: 'vertical-lr',
      lineHeight: '20px',
      height: '100%',
      marginTop: '-10px',
      right: '0',
      ...mixins.transform('rotate(180deg)'),
      textAlign: 'left',
      '&:lang(ar)': {
        right: 'auto',
        left: '0',
        textAlign: 'right'
      }
    }
  },
  inlineText: {
    display: 'inline'
  },
  hotelName: {
    display: 'block',
    paddingRight: '50px',
    '&:lang(ar)': {
      paddingRight: '0',
      paddingLeft: '50px'
    }
  },
  hotelNameSlide: {
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  errorForm: {
    font: "300 12px 'Roboto', sans-serif",
    color: '#d0021b',
    marginTop: '4px',
    display: 'block',
    marginLeft: '16px',
    '&:lang(ar)': {
      marginRight: '16px',
      marginLeft: '0'
    }
  },
  errorForm15: {
    font: "300 15px 'Roboto', sans-serif",
    color: '#d0021b',
    marginTop: '4px',
    display: 'block',
    marginLeft: '16px'
  },
  alertForm: {
    color: '#d0021b',
    display: 'block',
    font: "300 13px 'Roboto', sans-serif",
    '@media (min-width: 901px)': {
      fontSize: '16px'
    }
  },
  slideButton: {
    color: 'white',
    borderBottomColor: 'rgba(255,255,255,0.6)',
    fontSize: '9px'
  },
  epgText: {
    padding: '0 30px 0 30px',
    display: 'block'
  },
  messageAlert: {
    font: "300 12px 'Roboto', sans-serif",
    color: '#d0021b',
    marginTop: '4px',
    display: 'block',
    fontStyle: 'italic'    
  },
  truncateText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  
  //...textProperties,
  //...blockProperties,
};
